import React, { useState, useEffect } from 'react';
import SparkleIcon from '../SparkleIcon';
import style from './FoodItemHeaderCard.module.css';
import noImg from '../../../images/common/img_no_diet_02.png';
import reference01 from '../../../images/common/i_reference_ai.svg';
import reference02 from '../../../images/common/i_reference_search.svg';
import reference03 from '../../../images/common/i_reference_custom.svg';



/**
 * candidate.id 분류
 *   -1  : ai분석결과
 *   -99 : 직접입력
 *   그 외 : 검색
 */

const getReference = (cnddteId, hasImage) => {
    const id = Number(cnddteId);

    if (!Number.isFinite(id)) return null;   // 분류 불가 → 뱃지 미노출

    if (id === -99) return { icon: reference03, label: '직접입력' };

    if (id === -1) {
        return hasImage
            ? { icon: reference01, label: 'AI분석결과' }
            : { icon: reference03, label: '직접입력' };
    }

    return { icon: reference02, label: '검색' };
};

/**
 * 음식 상세 상단 카드 (이미지 + 이름 + 수량 + AI 분석)
 *
 * @param {string} name
 * @param {string} qty
 * @param {string} aiAnalysis  AI 분석 결과 텍스트
 * @param {string} image       음식 사진 URL (blob). 없으면 no-image
 */
const FoodItemHeaderCard = ({ name, qty, cnddteId, image }) => {
    const [broken, setBroken] = useState(false);

    useEffect(() => { setBroken(false); }, [image]);

    const hasImage = Boolean(image);
    const src = hasImage && !broken ? image : noImg;

    const reference = getReference(cnddteId, hasImage);

    return (
        <div className={style.card}>
            <div className={style.imgWrap}>
                <img
                    src={src}
                    alt=""
                    className={style.img}
                    draggable={false}
                    onError={() => setBroken(true)}
                />
            </div>
             <div className={style.body}>
                <div className={style.head}>
                    <h3 className={style.name}>{name}</h3>
                    <span className={style.qty}>{qty}</span>
                    {reference && (
                        <span className={style.reference}>
                            <img src={reference.icon} alt="" aria-hidden="true" />
                            {reference.label}
                        </span>
                    )}
                </div>
                {/* {aiAnalysis && (
                    <div className={style.aiBox}>
                        <SparkleIcon size={20} />
                        <p className={style.aiText}>{aiAnalysis}</p>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default FoodItemHeaderCard;